import React from 'react'
import LadingNaveBar from '../../components/Landing-page-components/ladingNaveBar/LadingNaveBar';
import { Outlet } from 'react-router-dom';
import "../../views/LandingPage/LandingPage.css";

const LandingPageLayOut = () => {
  return (
    <div className="LandingPage">
      <LadingNaveBar />
      {/* padding-top accounts for the floating nav height (68px) + top offset (16px) */}
      <div className="LandingPage-body" style={{ paddingTop: "90px" }}>
        <Outlet/>
      </div>
    </div>
  );
}

export default LandingPageLayOut